import { ADD_STATUS_INFO, ADD_STATUS_LIST, RESET_STATUS } from "./actions";

const initialState = {
  statusData: {
    personal: "",
    personalList:{},
    income: "",
    incomeList:[],
    education: "",
    eduList:[]
  },
};

const StatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_STATUS_INFO:
      let data = state.statusData;
      data[action.data[0]] = action.data[1];
      return {
        ...state,
        statusData: { ...data },
      };
      case ADD_STATUS_LIST:
      let data2 = state.statusData;
      data2[action.data[0]] = {...action.data[1]};
      return {
        ...state,
        statusData: { ...data2 },
      };
    case RESET_STATUS:
      return initialState;
    default:
      return state;
  }
};
export default StatusReducer;
